export default "* 5414dcc\t 2026-03-04T10:03:56-03:00 ";